import * as React from 'react'

import { Button } from 'sdk/button/Button'
import { NewsfeedBigCard } from 'pages/newsfeed/components/newsfeed-big-card/NewsfeedBigCard'
import { NewsfeedEntry, NewsfeedRecordType } from 'core/interfaces'
import { CONTACT_FORM_URL } from 'core/constants'
import cesHeroImage from 'pages/ces-2026-page/assets/ces-hero.jpg'

const heroEntry: NewsfeedEntry = {
  id: 0,
  title: 'Private Audio for Every Seat, in Every Car',
  preview: 'Be ready for the world\'s first true multi-zone car audio with active zone compensation! This breakthrough is enabled by real-time, GPU accelerated audio processing running directly on the car\'s infotainment platform, using as little as 2\u20133% of its available compute capacity. Soon in the cars on the roads.',
  type: NewsfeedRecordType.Article,
  views: 0,
  pathname: 'supercar-blondie',
  bg_image: {
    url: cesHeroImage,
    collage: { url: cesHeroImage },
  },
  human_date: '2026',
  read_time: '2 min',
  category: 'Announcement',
}

export const SupercarBlondieHero: React.FC = () => (
  <NewsfeedBigCard
    entry={heroEntry}
    showLearnMore={false}
    showTag={false}
    actions={(
      <Button
        as="link"
        target="_blank"
        href={CONTACT_FORM_URL}
      >
        Contact Us
      </Button>
    )}
  />
)
